import React from "react"

const Passbook = () => {
    return (
        <>
        </>
    )
}

export default Passbook;